export default "__VITE_ASSET__Bgeqsi8S__"